import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { RouterModule } from '@angular/router';
import { LegalComponent } from './legal.component';


import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';


@NgModule({
    imports: [
        CommonModule,
        AngularFontAwesomeModule,
        RouterModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    exports: [
        LegalComponent
    ],
  
    declarations: [
        LegalComponent
    ],
    providers: [
      
    ],
    entryComponents: [
        LegalComponent,
    ],
  
  })
  export class LegalModule { }

   // required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
  }